import React from 'react';

import GiftLine from './component';

export default React.memo(GiftLine);
